import React, { FC, ReactNode } from 'react';
import { shadeSafe } from '../../../CodesThatsGottaGoSomewhereElse';
import { Rect } from '../../../platform/geom/Rect';
import { Colors } from '../../../ui';
import { TextAlignment, TextSettings } from '../../canvas/entities/TextConventions';
import { RenderBounds, RenderBox, RenderInner } from '../../canvas/visualization/RenderHelpers';
import { RenderText } from '../../canvas/visualization/RenderText';
import { SmartBox, SmartBoxComputation } from './SmartBox';

const textSettings = TextSettings.from({
    ...TextSettings.default,
    fontSize: 0,
    textMargin: 10,
    textAlignH: TextAlignment.middle,
    textAlignV: TextAlignment.middle,
});

const RenderValue = React.memo<{ area: Rect, color: string, value: string }>(({ area, color, value }) => {
    return <RenderText bounds={area} settings={textSettings} value={value} customize={x => ({ ...x, color })} />;
});

const RenderDesign: FC<{ object: SmartBox }> = ({ object }) => {
    if (!object.background) return null;
    return <RenderBox
        inset="0"
        display="flex"
        alignItems="center"
        justifyContent="start"
        padding="4px"
        background={object.background}
        border={`solid 1px ${shadeSafe(.1, object.background)}`}
        borderBottom={`solid 2px ${shadeSafe(.1, object.background)}`}
        borderRadius="6px"
    />;
};

export const SmartBoxVisual: FC<{ object: SmartBox, children?: ReactNode }> = ({ object }) => {

    const bounds = new Rect(0, 0, object.width, object.height);

    return <>
        <RenderBounds object={object}>
            <RenderInner object={object}>
                <RenderDesign object={object} />
                <RenderValue
                    area={bounds}
                    color={Colors.contrastTextColorFor(object.background)}
                    value={`${SmartBoxComputation.get(object)}`}
                />
            </RenderInner>
        </RenderBounds >
    </>;
};
